import { Link } from "react-router-dom";
import { Instagram, Facebook, Youtube } from "lucide-react";
import { Wordmark, INSTAGRAM_URL, TIKTOK_URL, FACEBOOK_URL, YOUTUBE_URL, X_URL, TikTokIcon, XIcon } from "./Header";

export function Footer() {
  return (
    <footer data-testid="site-footer" className="bg-[#F3FBFC] text-ink">
      <div className="h-px bg-gradient-to-r from-transparent via-pool/60 to-transparent" aria-hidden="true" />
      <div className="container-site py-10">
        <div className="grid lg:grid-cols-12 gap-10">
          <div className="lg:col-span-5">
            <Wordmark dark />
            <p className="mt-6 text-slate-600 text-sm leading-relaxed max-w-sm">
              Good food. Good vibes. Good conversation. Poolside Cooking is a cooking variety show where food,
              entertainment, culture, and conversation come together.
            </p>
            <div className="mt-8 flex items-center gap-5 text-slate-400">
              <a
                href={INSTAGRAM_URL}
                target="_blank"
                rel="noreferrer"
                aria-label="Instagram @poolsidecookingshow"
                className="hover:text-pool transition-colors"
                data-testid="footer-social-instagram"
              >
                <Instagram className="h-5 w-5" />
              </a>
              <a
                href={TIKTOK_URL}
                target="_blank"
                rel="noreferrer"
                aria-label="TikTok @poolsidecooking"
                className="hover:text-pool transition-colors"
                data-testid="footer-social-tiktok"
              >
                <TikTokIcon className="h-5 w-5" />
              </a>
              <a
                href={FACEBOOK_URL}
                target="_blank"
                rel="noreferrer"
                aria-label="Facebook Poolside Cooking"
                className="hover:text-pool transition-colors"
                data-testid="footer-social-facebook"
              >
                <Facebook className="h-5 w-5" />
              </a>
              <a
                href={YOUTUBE_URL}
                target="_blank"
                rel="noreferrer"
                aria-label="YouTube Poolside Cooking"
                className="hover:text-pool transition-colors"
                data-testid="footer-social-youtube"
              >
                <Youtube className="h-5 w-5" />
              </a>
              <a
                href={X_URL}
                target="_blank"
                rel="noreferrer"
                aria-label="X Poolside Cooking"
                className="hover:text-pool transition-colors"
                data-testid="footer-social-x"
              >
                <XIcon className="h-5 w-5" />
              </a>
              <span className="text-xs text-slate-500 tracking-wide">@poolsidecookingshow · @poolsidecooking</span>
            </div>
          </div>

          <div className="lg:col-span-2">
            <p className="text-xs tracking-[0.25em] uppercase font-bold text-pool-deep mb-5">The Show</p>
            <ul className="space-y-3 text-sm text-slate-600">
              <li><Link to="/watch" className="hover:text-pool transition-colors" data-testid="footer-link-watch">Watch</Link></li>
              <li><Link to="/spotlight" className="hover:text-pool transition-colors" data-testid="footer-link-spotlight">Celebrity Guests</Link></li>
              <li><Link to="/about" className="hover:text-pool transition-colors" data-testid="footer-link-about">About</Link></li>
              <li><Link to="/press" className="hover:text-pool transition-colors" data-testid="footer-link-press">Media &amp; Press</Link></li>
            </ul>
          </div>

          <div className="lg:col-span-2">
            <p className="text-xs tracking-[0.25em] uppercase font-bold text-pool-deep mb-5">Poolside Life</p>
            <ul className="space-y-3 text-sm text-slate-600">
              <li><Link to="/cafe" className="hover:text-pool transition-colors" data-testid="footer-link-cafe">Café</Link></li>
              <li><Link to="/events" className="hover:text-pool transition-colors" data-testid="footer-link-events">Events</Link></li>
              <li><Link to="/shop" className="hover:text-pool transition-colors" data-testid="footer-link-shop">Shop</Link></li>
              <li><Link to="/cookbook" className="hover:text-pool transition-colors" data-testid="footer-link-cookbook">Cookbook</Link></li>
            </ul>
          </div>

          <div className="lg:col-span-3">
            <p className="text-xs tracking-[0.25em] uppercase font-bold text-pool-deep mb-5">Let's Talk</p>
            <ul className="space-y-3 text-sm text-slate-600">
              <li><Link to="/be-on-the-show" className="hover:text-pool transition-colors" data-testid="footer-link-be-on-show">Be on the Show</Link></li>
              <li><Link to="/contact" className="hover:text-pool transition-colors" data-testid="footer-link-guest">Be a Guest</Link></li>
              <li><Link to="/events#book-your-event" className="hover:text-pool transition-colors" data-testid="footer-link-book">Book an Event</Link></li>
              <li><Link to="/contact" className="hover:text-pool transition-colors" data-testid="footer-link-contact">General Inquiries</Link></li>
            </ul>
          </div>
        </div>

        <div className="mt-9 pt-6 border-t border-slate-300/60 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4">
          <p className="text-xs text-slate-500 tracking-wide">
            © {new Date().getFullYear()} Poolside Cooking. All rights reserved.
          </p>
          <div className="flex items-center gap-6">
            <Link to="/privacy" className="text-xs text-slate-500 hover:text-pool tracking-[0.2em] uppercase transition-colors" data-testid="footer-privacy-link">
              Privacy Policy
            </Link>
            <Link to="/terms" className="text-xs text-slate-500 hover:text-pool tracking-[0.2em] uppercase transition-colors" data-testid="footer-terms-link">
              Terms
            </Link>
            <Link
              to="/admin/login"
              className="text-xs text-slate-500 hover:text-pool tracking-[0.2em] uppercase transition-colors"
              data-testid="footer-admin-link"
            >
              Team Login
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
